module.exports = __webpack_public_path__ + "assets/4063d04aa466055557571253e38c978d.business_choice.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/src/styles/images/business_choice.png
 ** module id = 828
 ** module chunks = 1
 **/